import { Production, Stage } from "@/graphql/types"
import Button from "@/lib/components/common/button/button"
import LoadingIcon from "@/lib/components/common/loadingIcon"
import ResultBar from "@/lib/components/common/resultBar"
import { classifyDevice } from "@/lib/ts/device"
import { GetAllStages, GetOneAheadProductionInfo } from "@/graphql/documentNode"
import * as GraphQLClient from "@apollo/client"
import dayjs from "dayjs"
import { useMemo, useState } from "react"
import { useQuery } from "react-query"
import styled from "styled-components"
import { useParams } from "react-router-dom"

const ReservationMenu = () => {
    const pathParams = useParams<{ productionId: string }>()
  
    const productionId = pathParams.productionId


    const getProductionId = useMemo(() => {
        if(typeof productionId === 'string') {
            return parseInt(productionId)
        } if(typeof productionId === 'number') {
            return productionId
        }
        return -1
    }, [productionId])

    const [production, setProduction] = useState(undefined as Production | undefined)
    const [stages, setStages] = useState([] as Stage[])
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [loading, setLoading] = useState(false)

    const isMobile = useMemo(() => {
        const device = classifyDevice()
        return device === 'Android' || device === 'Mobile' || device === 'ios'
    }, [])

    const [getOneAheadProductionInfo] = GraphQLClient.useLazyQuery(GetOneAheadProductionInfo, {
        onCompleted: (data) => {
            setProduction(data.getOneAheadProductionInfo)
            setError(false)
            setSuccess(true)
        },
        onError: () => {
            setSuccess(false)
            setError(true)
        },
    })

    const [getAllStages] = GraphQLClient.useLazyQuery(GetAllStages, {
        onCompleted: (data) => {
            setStages(data.getAllStages)
            setError(false)
            setSuccess(true)
        },
        onError: () => {
            setSuccess(false)
            setError(true)
        },
    })

    useQuery([productionId], async () => {
        setLoading(true)
        await getOneAheadProductionInfo({
            variables: {
                productionId: getProductionId,
            }
        })
        await getAllStages({
            variables: {
                productionId: getProductionId,
            }
        })
        setLoading(false)
    })

    const buttons = useMemo(() => {
        return stages.map((stage) => {
            const reservable = dayjs.unix(stage.reservationStart) <= dayjs() && dayjs() <= dayjs.unix(stage.reservationLimit)
            return (
                <div key={`stage-select-${stage.id}`} className="button">
                    <Button 
                        label={stage.stageName}
                        buttonType={isMobile ? "default-red-white-shadow" : "powerful-red-white-shadow"}
                        onClick={() => { window.location.href = `./${getProductionId}/${stage.id}` }}
                        disabled={!reservable}
                        width={150}
                    />
                </div>
            )
        })
        
    }, [getProductionId, isMobile, stages])

    return (
        <ReservationMenuStyle>
            <div className="title-wrapper">
                <div className="title">{production ? production.name : ''}</div>
                <div className="sub-title">予約ページ</div>
            </div>
            <div className="instruction">
                上演回を選択してください。
            </div>
            <div className="buttons">
                {buttons}
            </div>
            <ResultBar 
                setSubmitError={setError}
                submitError = {error}
                failedMsg="読み込みに失敗しました。"
                setSubmitSucceeded={setSuccess}
                submitSucceeded={success}
                succeedMsg="ページの読み込みに成功しました。"
            />
            {
                loading ? <LoadingIcon /> : <></>
            }
        </ReservationMenuStyle>
    )
}

const ReservationMenuStyle = styled.div`
    .title-wrapper {
        text-align: center;
        margin: 10px auto 10px auto;
        .title {
            font-weight: bold;
        }
        .sub-title {
            font-size: 12px;
        }
    }
    .instruction {
        text-align: center;
        margin: 10px auto 10px auto;
        font-size: 14px;
    }
    .buttons {
        margin: 10px auto 10px auto;
        text-align: center;
        .button {
            margin: 10px auto 10px auto;
            text-align: center;

        }
    }
`

export default ReservationMenu